/**
 * [Internal module for displaying toaster notification. Script imported in public/index.html]
 * @param  {Object} data Data to be displayed
 */
export default function fyersToaster(data) {
  if (window.FyersToaster) {
    window.FyersToaster(data);
  }
}
